export default __webpack_public_path__ + "static/media/37.08d10fb4.png";